// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2783dca7","732":"be361ae4","977":"f9e6fef7"}[chunkId] + ".chunk.js";
};